import React, { useMemo } from 'react';
import { ENVS, getEnv } from '@adsk/acs-sc-web-platform-api';
import {
  useAlloyFeatureFlag,
  TOOL_IDS,
  useCurrentProject,
  useCurrentProductId,
} from '@adsk/alloy-provider';
import SideNavigation, {
  SideNavigationItem,
} from '@adsk/alloy-side-navigation';
import isExoRoute from '../../utils/isExoRoute';
import LocalSideNavigationItem from './LocalSideNavigationItem';

const LocalSideNavigation = (props) => {
  const currentProject = useCurrentProject();
  const currentProductId = useCurrentProductId();

  const { value: showProgressTrackingService } = useAlloyFeatureFlag(
    'show-progress-tracking-service'
  );

  const finalTools = useMemo(() => {
    const toolsFromProject =
      currentProject?.products?.find((p) => p.key === currentProductId)
        ?.tools || [];

    const filteredToolsFromProject = toolsFromProject.filter(
      (tool) =>
        !(
          !showProgressTrackingService &&
          tool.key === TOOL_IDS.PROGRESS_TRACKING
        )
    );

    const demoTool = {
      icon: 'beta',
      key: 'demo-app',
      name: 'demo-app',
      url: `/build/demo-app/projects/${currentProject?.id}`,
    };

    if (getEnv() !== ENVS.PRODUCTION && toolsFromProject.length) {
      return [demoTool, ...filteredToolsFromProject];
    }

    return filteredToolsFromProject;
  }, [currentProject, currentProductId, showProgressTrackingService]);

  return (
    <SideNavigation
      {...props}
      topItems={finalTools}
      renderItem={(itemProps) =>
        isExoRoute(itemProps.item.url) ? (
          <LocalSideNavigationItem {...itemProps} />
        ) : (
          <SideNavigationItem {...itemProps} />
        )
      }
    />
  );
};

LocalSideNavigation.propTypes = {
  ...SideNavigation.propTypes,
};

export default LocalSideNavigation;
